import {
  AeropayLogoSecondary,
  Flex,
  JaneGoldShadowLogo,
  JaneLogo,
  JanePayLogoWhite,
  Link,
  PartnerLogo,
  Typography,
} from '@iheartjane/reefer';

import { Background, BoxStyled, ThemedButton } from './SuccessScreen.styles';

interface SuccessScreenProps {
  afterBankLinking?: boolean;

  hideJanePayBranding: boolean;

  isJanePay: boolean;

  /** Function called when 'done' button is clicked */
  onDoneClick(): void;

  storePhoto?: string;
}

// Copied and modified from: libs/shared-ecomm/components/src/lib/bankLinkingModal/successScreen/successScreen.tsx
export const SuccessScreen = ({
  afterBankLinking = false,
  hideJanePayBranding,
  isJanePay,
  onDoneClick,
  storePhoto,
}: SuccessScreenProps) => {
  const noImage = isJanePay && hideJanePayBranding && !storePhoto;

  return (
    <Flex
      width="100%"
      height="100%"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
    >
      <BoxStyled background="primary-light" height="100%">
        <Background sparkly={!isJanePay} hideBranding={hideJanePayBranding}>
          <Flex
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            width="100%"
            height="100%"
            py={noImage ? 0 : 24}
          >
            {isJanePay && !hideJanePayBranding && (
              <JanePayLogoWhite my={40} height="41px" />
            )}

            {isJanePay && hideJanePayBranding && storePhoto && (
              <PartnerLogo
                name="store-logo"
                variant="store"
                image={storePhoto}
              />
            )}

            {!isJanePay && <JaneLogo size="xs" />}

            {!isJanePay && <JaneGoldShadowLogo height="55px" />}
          </Flex>
        </Background>
      </BoxStyled>
      <Typography
        variant="h2-semibold"
        textAlign="center"
        mt={24}
        mb={8}
        branded
      >
        {afterBankLinking
          ? `Welcome${hideJanePayBranding ? '' : ' to Jane Pay'}`
          : `Let's get your${
              hideJanePayBranding ? '' : ' Jane Pay'
            } account set up`}
      </Typography>

      {isJanePay && (
        <Typography textAlign="center" mb={24}>
          {afterBankLinking
            ? `You successfully linked your bank account. You can now${
                hideJanePayBranding ? '' : ' use Jane Pay to'
              } checkout on Jane and other participating cannabis stores.`
            : ''}
        </Typography>
      )}

      <ThemedButton
        full
        janePay={isJanePay && !hideJanePayBranding}
        label={afterBankLinking ? 'Continue' : 'Link bank account'}
        onClick={onDoneClick}
        variant="primary"
        size="large"
        mb={16}
      />
      {!afterBankLinking && (
        <Flex flexDirection="column" gap={8}>
          <Typography textAlign="center">
            By agreeing to link your bank, you agree to Aeropay’s{' '}
            <Link
              ariaLabel="link for Aeropay terms of service"
              href="https://www.aeropay.com/legal/terms-of-service"
              color="grays-mid"
            >
              Terms of Service
            </Link>{' '}
            and{' '}
            <Link
              ariaLabel="link for Aeropay privacy policy"
              href="https://www.aeropay.com/legal/privacy-policy"
              color="grays-mid"
            >
              Privacy Policy
            </Link>
          </Typography>
          <Flex alignItems="center" justifyContent="center">
            <Typography>Powered by</Typography>
            <AeropayLogoSecondary height={15} />
          </Flex>
        </Flex>
      )}
    </Flex>
  );
};
